// Finds the parent shadowRoot for the given element, otherwise returns null.
export const findParentShadowRoot = (el: HTMLElement) => {
  while (el?.nodeType !== 11 /* DOCUMENT_FRAGMENT (shadowRoot) */) {
    if (!el?.parentNode) {
      // el is not inside shadowRoot
      return null;
    }
    el = el.parentNode as HTMLElement;
  }
  return el;
};
